import { render, staticRenderFns } from "./SHIssueTicket.vue?vue&type=template&id=fca3e3b8&"
import script from "./SHIssueTicket.vue?vue&type=script&lang=ts&"
export * from "./SHIssueTicket.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports